export const EVENT_RISK_ASSESSMENT_REQUEST_NEW_VRA =
  'risk-assessment-requested-new';

export const TITLE_PROPERTY_NAME = 'title';
